import { type RouteRecordRaw } from 'vue-router'

import { formBuilderModuleRoutes } from '../builder/formBuilderModuleRouter'

const formBuilderRoutes: RouteRecordRaw[] = [
  ...formBuilderModuleRoutes,
  {
    component: async () => import('../views/FormBuilderFormsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'form'),
      title: 'website.forms',
    },
    name: 'brand.website.forms.home',
    path: 'forms',
  },
]

export { formBuilderRoutes }
